import React, { Component } from 'react';
import { Divider, Button, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Level extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      MaxLevel: 120,
      MaxSkillLevel: 120,
      MaxPartyMatchLevel: 120,
      MaxJobLevel: 7,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          CAP/Level Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>Maximum Character Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.MaxLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('MaxLevel')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Skill Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.MaxSkillLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('MaxSkillLevel')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Party Matching Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.MaxPartyMatchLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('MaxPartyMatchLevel')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>Maximum Job Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.MaxJobLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('MaxJobLevel')}
                  className="mb-4"
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
